import "./ConversationToggleTranslate.css";
import { useMode } from "../ConversationCard/ModeContext/ModeContext";

export default function ConversationToggleTranslate({ isLoading }) {
  const { mode, setMode } = useMode();
  const isTranslated = mode === "translated";

  return (
    <div className="toggle">
      <div className={`track ${isTranslated ? "translated" : ""}`}>

        <div className="option left" onClick={() => setMode("original")}>
          <i className="fas fa-comments" />
        </div>

        <div className="option right" onClick={() => setMode("translated")}>
          <i className="fas fa-globe" />
          {isLoading && (
            <span className="translate-loader"></span>
          )}
        </div>

        <div className="thumb" />
      </div>
    </div>
  );
}